// extracted by mini-css-extract-plugin
module.exports = {"H4":"styles_H4__3Gcsq","input":"styles_input__14xGg","docsDefault":"styles_docsDefault__3MIm9","docsOk":"styles_docsOk__5gK_t","toDocs":"styles_toDocs__36NGd"};